/**
 * motion-pref.ts — 學習側「減少晃動」旗標(給翻頁轉場用)。
 *
 * boss 的「減少晃動」存在 `progress.parentSettings.reduceMotion`(settings.ts),設定頁
 * 改值時會 broadcast `ef:reduce-motion-changed`(settings.ts:668)。本模組鏡像遊戲側
 * `src/game/systems/motion-prefs.ts` 的做法 —— 持一個 module-level 旗標,由 app init
 * 用 `setLearnReduceMotion` 灌入初值、並監聽 broadcast 即時更新,讓 pageShell 翻頁轉場
 * 不必每次去 load 整包 progress(避免把 game-coupled 的 progress import 拉進基礎 UI 層)。
 *
 * 同時尊重系統層 `prefers-reduced-motion: reduce`(與 theme.ts CSS 一致)——
 * 兩者任一為真即視為「減少晃動」。
 */

/** app 注入的「減少晃動」旗標(預設 false = 開場保留動畫,opt-in,與 isReduceMotion 同義)。 */
let _reduceMotion = false;

/**
 * 設定學習側「減少晃動」旗標。app init 讀 `isReduceMotion(progress)` 後灌入,
 * 設定頁 `ef:reduce-motion-changed` 也呼這裡更新。
 */
export function setLearnReduceMotion(flag: boolean): void {
  _reduceMotion = !!flag;
}

/**
 * 是否該減少動態(= 關閉翻頁轉場,瞬間切換)。
 *
 * app 注入旗標為真,或系統 `prefers-reduced-motion: reduce` 為真,皆回 true。
 */
export function prefersReducedMotion(): boolean {
  if (_reduceMotion) return true;
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch {
      /* matchMedia 不可用(老瀏覽器 / 測試)→ 退回旗標值 */
    }
  }
  return false;
}
